import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'

import { Button, Icon } from 'components'

import './modal.scss'

class Modal extends Component {
	componentDidMount() {
		window.addEventListener('keydown', this.onKeyDown, true)
	}

	componentWillUnmount() {
		window.removeEventListener('keydown', this.onKeyDown, true)
	}

	onKeyDown = e => {
		const { visible, closable } = this.props

		if (e.keyCode === 27 && visible && closable) {
			this.onClose()
		}
	}

	onClose = () => {
		const { onClose } = this.props

		if (onClose) {
			onClose()
		}
	}

	render() {
		const { title, children, visible, closable, width } = this.props

		const componentClass = 'c-modal'

		if (visible === false) {
			return null
		}

		return ReactDOM.createPortal(
			<div className={componentClass}>
				<div
					className={`${componentClass}__inner ${componentClass}__inner--width-${width}`}
					ref={this.modal}
				>
					{title && <h3>{title}</h3>}
					{children}
					{closable && (
						<Button
							className={`${componentClass}__close`}
							onClick={this.onClose}
							icon={<Icon name="close" size="small" />}
						/>
					)}
				</div>
			</div>,
			document.getElementById('root')
		)
	}
}

Modal.propTypes = {
	title: PropTypes.node,
	children: PropTypes.node.isRequired,
	visible: PropTypes.bool,
	closable: PropTypes.bool,
	onClose: PropTypes.func,
	width: PropTypes.oneOf(['default', 'large']),
}

Modal.defaultProps = {
	title: null,
	visible: true,
	onClose: null,
	closable: true,
	width: 'default',
}

export default Modal
